<template>
  <v-app class="main">
    <app-main-navbar v-if="display"></app-main-navbar>
    <v-main>
      <router-view></router-view>
      <v-snackbar v-model="snackbar" timeout="3000" right top :color="color">{{ text }}</v-snackbar>
    </v-main>
  </v-app>
</template>

<script>
import MainNavbar from "./core/components/MainNavbar.vue";
import { startSessionManager, stopSessionManager, hasValidToken, handleSessionExpired } from "./utils/session-manager.js";

export default {
  components: {
    "app-main-navbar": MainNavbar,
  },
  created() {
    const token = localStorage.getItem("apollo-done-token");
    if (token && !hasValidToken() && this.$route.path !== "/") {
      handleSessionExpired(this.$router, "TOKEN_EXPIRED");
    }
  },
  mounted() {
    this.$root.$on("show-alert", (type, text) => {
      this.text = text;
      this.color = type;
      this.snackbar = true;
    });
    this.initSessionManager();
  },
  watch: {
    $route() {
      this.initSessionManager();
    },
  },
  methods: {
    initSessionManager() {
      const token = localStorage.getItem("apollo-done-token");
      if (!token || this.$route.path === "/") {
        stopSessionManager();
        return;
      }
      if (!hasValidToken()) {
        handleSessionExpired(this.$router, "TOKEN_EXPIRED");
        return;
      }
      startSessionManager(this.$router);
    },
  },
  computed: {
    display() {
      var isVisible = false;
      const currentPath = this.$route.path;
      if (currentPath !== "/" && !currentPath.includes("invoice-download")) {
        this.$router.options.routes.forEach(element => {
          if (currentPath == element.path) {
            isVisible = true;
          } else if (element.children) {
            element.children.forEach(child => {
              if (currentPath === "/stock/" + child.path) {
                isVisible = true;
              }
            });
          }
        });
        if (!isVisible) {
          this.$router.replace({ path: "/" });
        }
      }
      return isVisible;
    },
  },
  data: () => ({
    snackbar: false,
    text: "",
    color: "",
  }),
};
</script>

<style>
.main {
  background-color: #e5e5e5 !important;
}

@font-face {
  font-family: "Gotham";
  src: local("Gotham"), url(./fonts/Gotham/GothamBook.ttf) format("swap");
}
</style>
